import * as React from "react";
import { HeadButton } from "../../components/atoms/HeadButton";
import { DEFAULT_WIDTH, Menu } from "../../components/molecules/Menu";
import { MenuItem } from "../../interface";
import SvgIcon from "@mui/material/SvgIcon";

export type DropDownProps = {
    id?: string;
    icon?: typeof SvgIcon;
    iconRight?: boolean;
    alignLeft?: boolean;
    title: string;
    onClose?: () => void;
    onClick?: (item: MenuItem) => void;
    items: MenuItem[];
    menuWidth?: number;
};

class Dropdown extends React.Component<DropDownProps> {
    public menuRootRef: React.RefObject<HTMLDivElement>;

    handleOutsideClick = (e: MouseEvent | TouchEvent) => {
        const target = e.target as Node | null;
        const btn = this.dropdownElement.current?.domElement.current;
        const menu = this.menuRootRef.current;

        const insideButton = !!(btn && target && btn.contains(target));
        const insideMenu = !!(menu && target && menu.contains(target));

        if (!insideButton && !insideMenu && this.state.menuOpen) {
            this.closeDropdown();
        }
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleOutsideClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleOutsideClick, true);
    }

    public dropdownElement: React.RefObject<HeadButton>;
    public state = {
        menuOpen: false,
        menuPos: [0, 0]
    };
    constructor(props: DropDownProps) {
        super(props);
        this.dropdownElement = React.createRef();
        this.menuRootRef = React.createRef();
    }
    public openDropdown = (): void => {
        const { menuWidth } = this.props;
        const domElement: React.LegacyRef<HTMLButtonElement> | undefined = this.dropdownElement.current?.domElement;
        const pos: DOMRect | undefined = (domElement as React.RefObject<HTMLButtonElement>).current?.getBoundingClientRect();
        if (pos) {
            this.setState({
                menuOpen: true,
                menuPos: [
                    this.props.alignLeft ? window.innerWidth - pos.left - (menuWidth || DEFAULT_WIDTH) : window.innerWidth - pos.right,
                    pos.bottom
                ]
            });
        }
    };
    public closeDropdown = (): void => {
        const { onClose } = this.props;
        this.setState({
            menuOpen: false
        });
        if (onClose) {
            onClose();
        }
    };
    public clickDropdown = (item: MenuItem): void => {
        const { onClick } = this.props;
        this.setState({
            menuOpen: false
        });
        if (onClick) {
            onClick(item);
        }
    };
    public render(): React.ReactElement {
        const { items, menuWidth, ...buttonProps } = this.props;
        const { menuOpen, menuPos } = this.state;
        return (
            <>
                <HeadButton {...buttonProps} ref={this.dropdownElement} onClick={this.openDropdown} />
                {menuOpen && (
                    <Menu
                        x={menuPos[0]}
                        y={menuPos[1]}
                        items={items}
                        onClick={this.clickDropdown}
                        onClose={this.closeDropdown}
                        menuWidth={menuWidth}
                        menuRef={this.menuRootRef}
                    />
                )}
            </>
        );
    }
}

export { Dropdown };
